import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'
import './lib/i18n'

// Apply persisted reduce-motion preference as early as possible
if (typeof window !== "undefined") {
  const saved = localStorage.getItem("reduce-motion");
  const prefers = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  if (saved === "1" || (saved === null && prefers)) {
    document.documentElement.classList.add("reduce-motion");
  }
}

// Best-effort anti-copy / anti-capture protection (cannot be 100% guaranteed in a browser)
if (typeof window !== "undefined") {
  document.addEventListener("contextmenu", (e) => e.preventDefault());
  document.addEventListener("dragstart", (e) => {
    const t = e.target as HTMLElement;
    if (t && (t.tagName === "IMG" || t.closest(".no-copy"))) e.preventDefault();
  });
  document.addEventListener("copy", (e) => {
    const sel = window.getSelection()?.toString() ?? "";
    if (!sel) e.preventDefault();
  });
  document.addEventListener("keydown", (e) => {
    const k = e.key.toLowerCase();
    // Block PrintScreen, Save, View Source, DevTools shortcuts
    if (k === "printscreen") { e.preventDefault(); navigator.clipboard?.writeText(""); }
    if ((e.ctrlKey || e.metaKey) && ["s", "u", "p"].includes(k)) e.preventDefault();
    if (e.key === "F12") e.preventDefault();
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && ["i", "j", "c"].includes(k)) e.preventDefault();
  });
  // Blur the page when it loses focus (deters screen recording overlays)
  window.addEventListener("blur", () => document.body.classList.add("opacity-0"));
  window.addEventListener("focus", () => document.body.classList.remove("opacity-0"));
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
